import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=13794c07&scoped=true"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"
import style0 from "./addContact.vue?vue&type=style&index=0&id=13794c07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13794c07",
  null
  
)

export default component.exports